import { useState, useEffect } from "react";
import { getReferralStats,getReferralCoupons } from "../../services/master.service";
import "./ReferralCoupon.css";

export default function ReferralCoupon() {
  const TARGET = 4;

  const [showCopyAlert, setShowCopyAlert] = useState(false);
  const [referralCount, setReferralCount] = useState(0);
  const [rewardsEarned, setRewardsEarned] = useState(0);
  const [coupons, setCoupons] = useState([]);
  const [couponUsed, setCouponUsed] = useState(false);


  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const referralCode = user?.referral_code || null;


  const percentage = Math.min(
    Math.round((referralCount / TARGET) * 100),
    100
  );

  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setShowCopyAlert(true);
      setTimeout(() => setShowCopyAlert(false), 2000);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  useEffect(() => {
    const fetchReferralStats = async () => {
      try {
        const res = await getReferralStats();
        const data = res?.data;

        const total = data?.total_referrals ?? 0;
        const rewarded = data?.rewarded_referrals ?? 0;

        const earned = Math.floor(rewarded / TARGET);

        let progress = total % TARGET;
        if (progress === 0 && total > 0) {
          progress = TARGET;
        }

        setReferralCount(progress);
        setRewardsEarned(earned);

      } catch (error) {
        console.error("Referral stats fetch failed", error);
      }
    };

    fetchReferralStats();
  }, []);

  useEffect(() => {
  const fetchReferralCoupons = async () => {
    try {
      const res = await getReferralCoupons();
      const data = res?.data ?? [];
      console.log(data)
      setCoupons(data)

    } catch (error) {
      console.error("Referral coupon fetch failed", error);
    }
  };

  fetchReferralCoupons();
}, []);


  return (
    <div className="container">
      <div className="referral-card dark">

        <h3 className="title">Referral</h3>

        {/* 🏆 Rewards earned */}
        <div className="reward-summary">
          🎉 Rewards earned: <strong>{rewardsEarned}</strong>
        </div>

        {/* 🔵 PROGRESS */}
        <div
          className="circle-progress"
          style={{ "--value": `${percentage}%` }}
        >
          <div className="circle-inner">
            <span className="circle-value">{percentage}%</span>
            <span className="circle-sub">Completed</span>
          </div>
        </div>

        <div className="progress-text">
          {referralCount} / {TARGET} referrals completed
        </div>

        <div className="progress-hint">
          Share app with {TARGET - referralCount} more friends
        </div>

        {/* 🔑 CODES SECTION */}

        <h2 className="title">Referral Code</h2>
        <div className="referral-section">
          <div className="referral-box">
            <span className="coupon-code">{referralCode}</span>

            <button
              className="copy-btn"
              onClick={() => handleCopy(referralCode)}
            >
              Copy
            </button>

            
            
          </div>
        </div>
        {/* 🎁 Coupon appears BELOW referral code */}
        <h2 className="title">Coupons</h2>
        <div className="coupon-section">
          <div className="coupon-row">
                {coupons.filter(coupon => !coupon.used).length > 0 ? (
                  coupons
                  .filter(coupon => !coupon.used)
                  .map((coupon, index) => (
                    <div className="coupon-box" key={index}>
                      <span className="coupon-code">{coupon.code}</span>

                      <button
                        className="copy-btn"
                        onClick={() => handleCopy(coupon.code)}
                      >
                        Copy
                      </button>
                    </div>
                  ))
                ) : (
                  <p>No coupons available</p>
                )}
  </div>
</div>


        {showCopyAlert && (
          <div className="copy-alert">✅ Code copied!</div>
        )}
      </div>
    </div>
  );
}
